<template>
	<div class="b">
		<Nav current="我的公司"></Nav>
		<div class="info clearfix">
			<div class="item clearfix">
				<div class="item-l breadCrumb"><a>系统管理</a> > <a>角色管理</a> > <a>{{roleName}}</a> > 权限设置
					<!-- <el-button
						style="margin: 0 8px; vertical-align: 1px;" size="mini" type="primary" class="el-button btnSty"
						@click="back">
						返回
					</el-button> -->
				</div>

			</div>
		</div>
		<div class="content">
			<div class="rbac clearfix">
				<div class="tablelist" style="background: #f8f8f8; position: relative;">
					<div class="tablelist-topnav">
						<div class="topnav-btns">
							 <el-popover
							 	v-for="(item,index) in authList" 
								:key="index"
								placement="top-start"
								title=""
								width="200"
								trigger="hover"
								:content="item.des">
								<div 
								slot="reference"
								:class="{'active': index === currentIndex }" 
								:key="index"
								@click="changeSelectBtn(index)"
								>{{item.title}}</div>
								
							</el-popover>
							
						</div>
						<div class="clearfix" style="font-size: 14px; line-height: 30px;" v-if="currentIndex === 1">
							<div class="l">当前系统：</div>
							<div class="l">
								<el-select size="mini" v-model="value" placeholder="请选择" @change="changeValue">
									<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</div>	

						</div>
					</div>
					
					<!-- <el-button style="position: absolute; right: 10px; top: 34px;" size="mini" type="primary" @click="submit(1)"
						class="el-button btnSty">保存</el-button> -->

					<ul id="treeDemo" class="ztree common-ztree ztree2" v-show="identical"></ul>
					<ul id="treeDemo1" class="ztree common-ztree ztree2" v-show="!identical"></ul>
				</div>
				<!-- <div class="tablelist" style="background: #f8f8f8;">
					<h3>数据权限</h3>
					<div class="clearfix" style="font-size: 14px; line-height: 30px;">
						<div class="l">当前系统：</div>
						<div class="l">
							<el-select size="mini" v-model="value" placeholder="请选择" @change="changeValue">
								<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>

							<el-button style="margin: 0 8px;" size="mini" type="primary" class="el-button btnSty" @click="submit(2)">
								保存</el-button>
							<span style="font-size: 12px;">保存所选系统下权限设置</span>
						</div>
					</div>
					<ul id="treeDemo1" class="ztree"></ul>
				</div> -->
				
				<div class="tips">
					<div style="position:relative">
						<div class="el-check-all" style="padding-left: 20px;background: #F1F1F1;" v-show="!selectTreeNode.name">{{ ['组织机构权限','数据权限'][currentIndex] }}</div>
						<div style="padding-left: 20px;width: 100%;background: #F1F1F1;box-shadow: 0px 1px 0px 0px #DADBE4;overflow:hidden">
							<el-checkbox v-show="childs.length" class="el-check-all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
							<el-checkbox style="margin-left:30px" v-show="selectTreeNode.name" v-model="selectTreeNode.checked" class="el-check-all">"{{selectTreeNode.name}}"菜单权限</el-checkbox>
							<span style="margin-left:30px" class="el-check-all" v-show="selectTreeNode.treeGrade">({{ selectTreeNode.treeGrade }})</span>
						</div>
						<!-- 组织机构权限 -->
						<div class="check-group-cont" v-if="identical">
							<div v-show="childs.length" v-for="item in childs" :key="item.id" class="el-check-group">
								<p>{{item.name}}</p>
								<div>
									<el-checkbox-group v-model="checkedChilds" @change="handlecheckedChildsChange">
										<el-checkbox v-for="item in item.children" :label="item" :key="item.id">{{item.name}}</el-checkbox>
									</el-checkbox-group>
								</div>
							</div>
						</div>
						<div class="check-group-cont" v-else>
							<!-- 数据权限定制数仓批量权限模版 -->
							<template v-if="isWarseHouse">
								<div class="el-check-group">
									<p>定制数仓批量权限模版：</p>
									<div class="excel-box">
										<div class="item">
											<div class="item-l">
												<div class="name">定制数仓批量权限模版文件</div>
											</div>
											<div class="item-btn download" @click="dataWarehouseDownloadTemplate">
												下载
											</div>
										</div>
									</div>
								</div>
								<div class="el-check-group">
									<div class="el-check-group-title">我增加的历史数仓权限：<div class="item-btn upload" @click="dataWarehouseUploadTemplateBefore">上传</div></div>
									<div class="excel-box" v-if="roleMenuGetImportLogs && roleMenuGetImportLogs.length">
										<div class="item">
											<div class="item-l" v-for="(item, index) in roleMenuGetImportLogs" :key="index">
												<div class="name">{{ item.name }}</div>
												<div class="date">最近上传日期：{{ item.date}}</div>
											</div>
											<div class="item-btn download" @click="dataWarehouseDownloadTemplate(item)">修改</div>
										</div>
									</div>
								</div>
							</template>
							<div v-show="childs.length" v-for="(item,index) in childs" :key="item.id" class="el-check-group">
								<!-- :indeterminate="isIndeterminate" -->
								<!-- 复选框增加全选按钮 -->
								<p v-if="item.children[0] && !item.children[0].eradio">
									<el-checkbox class="el-check-all-sub" :indeterminate="item.isIndeterminate" v-model="item.checked" @change="handleCheckAllSubChange(item.checked,index)"></el-checkbox>
								{{item.name}}</p>
								<p v-else>{{item.name}}</p>
								<div v-if="item.children[0] && !item.children[0].eradio">
									<el-checkbox-group v-model="diffCheckChilds[index]" @change="handleDiffcheckedChildsChange(item,index)">
										<el-checkbox v-for="child in item.children" :label="child" :key="child.id">{{child.name}}</el-checkbox>
									</el-checkbox-group>
								</div>
								<div v-else>
									<el-radio-group v-model="selectChildId[index]" @input="(val)=>changeBandding(val,item,childs,index)">
										<span style="position: relative;" v-for="child in item.children" :key="child.id" @click="changeBandding(child.id, item, childs, index,'span')">
											<el-radio  :class="selectTreeNode && selectTreeNode.iconSkin.includes('icon502') && child.name === '自定义' ? 'disabled-radio': ''"  :label="child.id" :disabled="(item.name === '修改历史时间段' && child.name === '自定义')"  >
												<span @click="changeBandding(child.id, item, childs, index,'span')">{{child.name}}</span>
											</el-radio>
											 <el-alert
											 	v-if="child.name === '自定义' && (selectChildId[index] === child.id) && !child.customData"
												title="至少选择一个组织机构或过滤条件"
												style="position: absolute;left:-10px;font-size: 12px;bottom:-25px;width:225px;padding:0;background-color: transparent!important;display: inline!important;"
												type="error" :closable="false">
											</el-alert>
										</span>
									</el-radio-group>
								</div>
								
							</div>
						</div>
						
						<div class="check-bottom-btns">
						   <el-button class="el-btn-common" @click="back">返回</el-button>
						   <el-button class="el-btn-common" :disabled="!selectTreeNode.name" type="primary" @click="submit(currentIndex+1)">确定</el-button>
						</div>
						
				    </div>
						<div class="tip-div">
							<el-popover
								ref="popover"
								popper-class="rolePopover"
								placement="top-end"
								width="484"
								trigger="click">
								<div class="tip-div-txt">
									<div class="close" @click="closePopover()">×</div>
									<p style="background: #fff;">
										1. 勾选checkbox表示本角色具有访问菜单或者操作的权限。
										<br> 2. 当有radio单选按钮时,表示本菜单可以设置用户的数据查看范围。
										<br> 3. <span class="red-txt">修改权限后,角色所对应的用户需要重新登录或者关闭浏览器再打开生效。</span>
										<br> 4. 当勾选的项有灰色背景时，表示该项下的子菜单没有全部勾选。
										<br> 5. 当新建了表单或者报表后，权限需要再次单独勾选。
										<br> 6. 表单历史数据查看范围可以自定义查询规则，支持组织结构和表单数据过滤。
										<br> 7. 表单历史数据查看范围配置组织结构和表单数据过滤规则的时候，请及时保存，系统不会保存页面中间状态。
									</p>
								</div>
								<div class=""  slot="reference">设置角色 {{ roleName }} 的权限,注意事项 ></div>
							</el-popover>
						</div>
					
					
				</div>
			</div>
		</div>
		<el-dialog title="自定义过滤器" :visible.sync="dialogFormVisible">
			<el-radio-group v-if="isModuleStatistics" v-model="tabPosition" style="margin-bottom: 30px;position: absolute;right:300px;top:10px;z-index: 1000;">
				<el-radio-button label="isDefalut">分类汇总项</el-radio-button>
				<el-radio-button label="notDefalut">非分类汇总项</el-radio-button>
			</el-radio-group>	
			<template>
				<div v-loading="isDilogLoading" element-loading-background="rgba(255, 255, 255, 0.8)" style="min-height: 406px;">
					<ul v-show="tabPosition==='isDefalut' && dataIsDefault.length" id="treeDemo2" class="ztree common-ztree"></ul>
					<div v-show="tabPosition==='notDefalut'">
						<el-form ref="form" label-width="220px">
							<el-form-item :lzabel="item.name" v-for="(item,index) in dataNotDefaultList" :key="index">
								<el-input v-model="item.value" style="width:400px"></el-input>
							</el-form-item>
						</el-form>	
					</div>

					<!-- <el-tree :load="loadNode" show-checkbox node-key="id" ref="tree" highlight-current
						:props="defaultProps" lazy
						@check-change="handleCheckChange">
					</el-tree> -->
				</div>
			</template>
			<span slot="footer" class="dialog-footer">
				<el-button plain size="mini"
					style="color: #55c4b7!important;background-color: #fff!important;border: 1px solid #55c4b7!important;"
					type="primary" @click="close()"
					class="el-button">取消</el-button>
				<el-button  size="mini"  type="primary" @click="saveCustomize"
				class="el-button">保存</el-button>
				
			</span>
			
		</el-dialog>
		<!-- <el-dialog title="自定义过滤器" :visible.sync="dialogFormVisible2">
			<el-button style="position: absolute; right: 50px; top: 14px;" size="mini" type="primary" @click="saveCustomize2"
				class="el-button btnSty">保存</el-button>
			<el-button style="position: absolute; right: 114px; top: 14px; background: #fff; color: #409EFF;" size="mini"
				type="primary" @click="close2()"
				class="el-button btnSty">关闭</el-button>
			<template>
				<ul id="treeDemo2" class="ztree"></ul> -->
				<!-- <el-tree :load="loadNode" show-checkbox node-key="id" ref="tree" highlight-current
					:props="defaultProps" lazy
					@check-change="handleCheckChange">
				</el-tree> -->
			<!-- </template>
			
		</el-dialog> -->
		<el-dialog v-loading="loading" class="hnc-dialog" title="上传定制数仓批量权限模版" :visible.sync="dialogDataWarehouseUploadTemplateVisible" center>
			<!-- 错误提示 -->
				<template v-if="templateVisibleType == 1">
					<div class="error-box">
						<div class="title blue-txt">以下导入数据输入错误，导入失败，请重新输入后导入。</div>
						<div class="lists">
							<div class="item" :key="index" v-for="(item,index) in errorMsgList">
								<template v-if="item.msg">
									{{ item.row }}行{{ item.col }}列：{{item.msg}}
								</template>
								<template v-else>{{item}}</template>
							</div>
						</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button class="el-btn-common" type="primary" @click="templateVisibleType = false">确定</el-button>
					</span>
				</template>
				<template v-else>
					<div>
						<el-upload
							class="upload-template"
							ref="upload"
							:limit = "1"
							:before-upload="handleAvatarBefore"
							action="/organizationstructure/roleMenu/importModuleConfig"
							:on-error="handleAvatarError"
							:on-success="handleAvatarSuccess"
							:file-list="fileList"
							:auto-upload="false">
							<div class="content">
								<div slot="tip" class="upload-template-tip">
									选择文件：
								</div>
								<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
							</div>
						</el-upload>
					</div>
					<div  class="el-upload-tip">
						<div class="tip-l">说明：</div>
						<div class="tip-r">
							1.文件格式：只支持.xls为后缀的Excel文件。<br>
							提示：导入时输入错误的信息和做修改的权限会有弹框提示，未做修改的权限系统会按原有的权限保存。
						</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button class="el-btn-common" @click="dialogDataWarehouseUploadTemplateVisible = false">取消</el-button>
						<el-button class="el-btn-common" type="primary" @click="dataWarehouseUploadTemplate">确定</el-button>
					</span>
				</template>
		</el-dialog>
	</div>
</template>
<script>
	import Nav from "@/components/Nav.vue";
	import axios from 'axios'
	import apiData from "@/config/api";
	import http from "@/config/httpConfig";
	import { Message,Loading } from 'element-ui'
	var IDMark_A = "_a";
	var organizationAndFilterRoleMenuNode;
    var tree2 = null// 000将tree2修改为全局变量
	let app
	let allTreeItems = {};
	let isCanDelete // 是否可以删除

	function ajaxDataFilter(treeId, parentNode, responseData) {
		if (responseData && responseData.code && responseData.code == 400) {
			alert(responseData.msg)
			return
		}
		var responseData = responseData.data
    if (responseData) {
      return responseData;
    }
	};
	var asyncData = {
		enable: true,
		dataFilter: ajaxDataFilter,
		type: "get",
		autoParam: ["id","type"]
	}

	function getFont(treeId, node) {
		return node.font ? node.font : {};
	}
	function selectOrganizationAndFilter(ids, names){
		if(organizationAndFilterRoleMenuNode){
			organizationAndFilterRoleMenuNode.customData = ids;
		}
	}
	function modifyHistoryTime() {
		var zTree = $.fn.zTree.getZTreeObj("treeDemo1");
		var node = zTree.getNodes();
		var nodes = zTree.transformToArray(node);
		for (var i = 0, l = nodes.length; i < l; i++) {
			if (nodes[i].id.match(RegExp(/-1/)) || nodes[i].id.match(RegExp(/-2/))) {
				zTree.setChkDisabled(nodes[i], true);
			}
		}
	}
	//自定义radio
	function addDiyDom(treeId, treeNode) {
		var aObj = $("#" + treeNode.tId + IDMark_A);
		if (treeNode.eradio) {
			//选隐藏checkbox
			var chectBtn = $("#" + treeNode.tId + "_check");
			if (chectBtn) chectBtn.remove();
			//再设置radio
			var checked = treeNode.checked ? "checked" : "";
			var chkDisabled = treeNode.chkDisabled
			var purl = treeNode.purl
			if (purl === "form_limits_edit_formdata") { //编辑历史数据
				var editStr =
					'<span style="display:none;" + "_check class=" button chk radio_false_disable" onclick="editDisabledFunc()"></span>'
				editStr += "<input type='radio' class='radioBtn' id='" + treeNode.tId + "_radio'	name='radio_" + treeNode
					.getParentNode().id + "' " + checked + "	onfocus='this.blur();'></input>";
			} else {
				if (chkDisabled) { //禁用
					var editStr =
                    // 000修改点击修改历史时间段，自定义和永久点击报错问题
                    // '<span id="treeNode.tId" + "_check class=" button chk radio_false_disable" treenode_check="" onclick="chkDisabledFunc()"></span>'
						'<span id="treeNode.tId" + "_check class=" button chk radio_false_disable" treenode_check=""></span>'
				} else {
					var editStr = "<input type='radio' class='radioBtn' id='" + treeNode.tId + "_radio'	name='radio_" + treeNode
						.getParentNode().id + "' " + checked + "	onfocus='this.blur();'></input>";
				}
			}
			aObj.before(editStr);
			var btn = $("#" + treeNode.tId + "_radio");
			if (btn) btn.bind("click", function () {
				if ((treeNode.purl === 'form_limits_view_formdata' || treeNode.purl === 'form_limits_view_report') && treeNode.name === '自定义') {
					organizationAndFilterRoleMenuNode = treeNode;
					var pId = treeNode.pId;
					var form_id = pId.split("_")[1];
					console.log(app)
								console.log('哦哦偶的事这里--3')

					app.dialogFormVisible = true
					app.formId = form_id
					app.menuId = pId
					app.getTreeData()
					// app.getCategorylist()
					// app.loadNode()
					// showUrlDialog(
					// 	'/module/organizationAndFilterRoleMenu.action?role_id=8a9e23296ca50893016cb1ec4fcf18b8&menu_id=' + pId
					// 	.split("_")[0] + '&form_id=' + form_id, '自定义过滤器', '420px', '80%', 'dialog_organizationAndFilter');
				}
			});
			if (btn) btn.bind("change", function () {
				checkBrand(treeId, treeNode, btn);
			});
		}
	}
	//节点展开
	function expandNode(event, treeId, treeNode) {
		if ($(event.currentTarget).attr('id') == 'treeDemo1') {
			var zTree = $.fn.zTree.getZTreeObj("treeDemo1");
		} else {
			var zTree = $.fn.zTree.getZTreeObj("treeDemo");
		}
		if (treeNode.name === "编辑历史数据") {
			var btn = $("#" + treeNode.tId + "_check");
			var node = zTree.getNodes();
			var nodes = zTree.transformToArray(node);
			var childNodes = null
			var type = ''
			var parent = null
			// var checkedNodes = zTree.getCheckedNodes()
			for (var i = 0, l = nodes.length; i < l; i++) {
				if (nodes[i].pId === treeNode.pId && nodes[i].name === "查看范围") {
					parent = nodes[i].tId
					childNodes = nodes[i].children
					break
				}
			}
			console.log(childNodes)
			for (var j = 0, m = childNodes.length; j < m; j++) {
				console.log(childNodes[j])
				console.log(childNodes[j].purl)
				console.log(childNodes[j].purl === "form_limits_view_formdata", childNodes[j].checked, childNodes[j].purl ===
					"form_limits_view_formdata" &&
					childNodes[j].checked)
				if (childNodes[j].purl === "form_limits_view_formdata" && childNodes[j].checked) {
					type = childNodes[j].name
					break
				}
			}
            // 000注释代码
			// historyIsEdit(btn.parent().find('ul'), null, type)
		}
	}
	//radio被选中时的操作
	function checkBrand(treeId, treeNode, btn) {
		var nextLi = null
		var items = []
		if (treeNode.purl === 'form_limits_view_formdata') {
			nextLi = btn.parent().parent().parent().next().find('ul>li')
			console.log(nextLi)
			if (nextLi.length > 0) {
				historyIsEdit(btn.parent().parent().parent().next().find('ul'), nextLi, btn.parent().text())
				for (var index = 0; index < nextLi.length; index++) {
					var liName = nextLi[index].id.trim().split("_")
					items.push(parseInt(liName[1]) - 1)
				}
				// modifyHistoryTime()
			}
		}

		//alert("change:"+treeNode.name+" "+btn.prop("checked"));
		if (btn.prop("checked")) {
			var treeObj = $.fn.zTree.getZTreeObj(treeId);
			var node = treeObj.getNodes();
			var nodes = treeObj.transformToArray(node);
			//设置自己为选中
			treeObj.checkNode(treeNode, true, true, true);
			//同时设置同组其它的隐藏数据为非选中状态
			var others = treeObj.getNodesByParam("pId", treeNode.pId);
			if (others.length > 0) {
				var objNode = null;
				for (var i = 0; i < others.length; i++) {
					objNode = others[i];
					if (treeNode.id != objNode.id && objNode.checked && objNode.eradio) {
						treeObj.checkNode(objNode, false, true, true);
					}
				}
			}
			if (nextLi && nextLi.length > 0) { //清空编辑历史
				var objNode = null;
				for (var i = 0, l = items.length; i < l; i++) {
					console.log(nodes[items[i]])
					if (nodes[items[i]].eradio) {
						console.log(nodes[items[i]])
						treeObj.checkNode(nodes[items[i] - 1], false, true, true);
					}
				}
			}

			console.log('哦哦偶的事这里')
			//如果是自定义按钮，弹出框
			if ("自定义" === treeNode.name) {
				organizationAndFilterRoleMenuNode = treeNode;
				var pId = treeNode.pId;
				var form_id = pId.split("_")[1];
				app.dialogFormVisible = true
				app.formId = form_id
				app.menuId = pId
				app.getTreeData()
				// app.getCategorylist()
				// app.loadNode()
				// showUrlDialog('/module/organizationAndFilterRoleMenu.action?role_id=8a9e23296ca50893016cb1ec4fcf18b8&menu_id='+pId.split("_")[0]+'&form_id='+form_id,'自定义过滤器','420px','80%','dialog_organizationAndFilter');
			}

		}
	}
	//结点被选中的操作
	function zTreeOnCheck(event, treeId, treeNode) {
		if (treeNode.eradio) return;
		var treeObj = $.fn.zTree.getZTreeObj(treeId);
		//对radio的操作
		if (treeNode.isParent) {
			//先取出本结点下面所有的radio
			var radios = treeObj.getNodesByParam("eradio", true, treeNode);
			var radioPid = null;
			if (radios.length > 0) {
				for (var i = 0; i < radios.length; i++) {
					if (radioPid != radios[i].pId) {
						radioPid = radios[i].pId;
						if (treeNode.checked) {
							//设置一个为选中状态
							var radioNodes = treeObj.getNodesByParam("pId", radioPid);
							var tmp = 0;
							for (var j = 0; j < radioNodes.length; j++) {
								var radioNode = radioNodes[j];
								if (radioNode.eradio) {
									if (tmp == 0) {
										tmp += 1;
										treeObj.checkNode(radioNode, true, true, true);
										$("input:radio[name=radio_" + radioPid + "]").first().prop('checked', true);
									} else {
										treeObj.checkNode(radioNode, false, true, true);
									}
								}
							}

						} else {
							//设置为不选中
							var radio = $("input:radio[name=radio_" + radioPid + "]:checked");
							if (radio) radio.prop('checked', false);
						}
					}
				}
			}
		}
	}
	function zTreeOnAsyncSuccess(event, treeId, treeNode, msg) {
		alert(treeNode ? treeNode.tId + ", " + treeNode.name : "No node");
	}
  function F(){
		return {
			view: {
				showLine: true, /*不显示节点之间的连接线*/
			},
			check: {
				enable: true,
				url: '',
				chkboxType:  { "Y": "", "N": "" },
			},
			async: asyncData,
			simpleData: {
				enable: true,
			},
			callback: { 
				onClick: function (e, treeId, treeNode, clickFlag) {
					console.log(e, treeId, treeNode, clickFlag)
					tree2.checkNode(treeNode, !treeNode.checked, true); 
				},
				// 初始化成功函数
				onAsyncSuccess:  (event, treeId, treeNode, msg) => {
							// 懒加载完成后，检查是否有需要递归展开的子节点
							if (treeNode && treeNode.children && treeNode.children.length > 0) {
								// 找出有checked或halfCheck状态的子节点并递归展开
								let selData = treeNode.children.filter(item=>item.checked || item.halfCheck);
								if(selData.length){
									selData.forEach(childNode => {
										// 递归展开子节点
										app.expandSpecificNode($.fn.zTree.getZTreeObj("treeDemo2"), childNode.id);
									});
								}
								app.isDilogLoading = false;
							}
					}
				
			},	
		};
	}
	
	export default {
		components: {
			Nav,
		},
		data() {
			return {
				authList: [{
					title: '组织机构权限',
					des: '授予用户管理公司组织架构的权限',
				},
				{
					title: '数据权限',
					des: '授予用户对定制/表单数据的查看及编辑权限',
				}], // 2026/03/09 lucina 权限列表配置
				loading: false,
				isDilogLoading: false, // 自定义弹框loading
				categorylist: [],
				defaultProps: {
					children: 'zones',
					label: 'name',
					isLeaf: 'leaf'
				},
				dialogFormVisible: false,
				roleName: '我的角色',
				roleId: '',
				setting2: F(),
				options: [],
				value: '',
				zNodes: [],
				zNodes1: [],
				currentIndex: 0,
				checkedChilds: [],
			    childs: [],
				diffCheckChilds: [],
				selectChildId: [],
				isIndeterminate: false,
				checkAll: false,
				selectTreeNode: {},
				// dialogFormVisible2: false
				tabPosition: 'isDefalut',
				dataNotDefaultList: [],
				isModuleStatistics: false,
				onlyOne: 0,
				dataIsDefault: [],
				dialogDataWarehouseUploadTemplateVisible: false,//数仓权限上传模版-弹框
				roleMenuGetImportLogs: [],//角色导入历史查询接口
				fileList: [],//上传文件
				errorMsgList: [],
				templateVisibleType: 0,//0上传 1错误列表
				isWarseHouse: false,
			};
		},
		computed: {
			identical(){
				return this.currentIndex === 0;
			},
			grade(){
				const treeGrade = this.selectTreeNode.treeGrade?this.selectTreeNode.treeGrade.split('/'):[];
				if(treeGrade.length > 1){
                  return treeGrade.splice(0,treeGrade.length-1).join('/');
				}else{
					return '';
				}
				
			},
			// 2026-03-09 lucina 获取当前登录的编号信息
			switchboardIdentity(){
				let switchboardIdentity = localStorage.getItem("switchboardIdentity");
				return switchboardIdentity ? JSON.parse(switchboardIdentity) : {}
			},
			
		},
		watch: {
			isIndeterminate(val){			
				if(val){
					this.mapAddChecked(this.selectTreeNode);
			        console.log(this.selectTreeNode,'111');
				}
				 
			},
			checkAll(val){		
				if(val){
				   this.mapAddChecked(this.selectTreeNode);
			       console.log(this.selectTreeNode,'222');  
				}
			},
			// 2026-03-09 lucina 关闭弹框时销毁树
			dialogFormVisible(val){
				
				if(val){
					// this.isOperateDialogSure = false
					if(tree2 && (isCanDelete ?? false)){
						tree2.destroy();
						tree2 = null
					}
						
					// 滚动到dialog顶部
					this.$nextTick(() => {
						if (this.$refs.customFilterDialog) {
							const dialogBody = this.$refs.customFilterDialog.$el.querySelector('.el-dialog__body');
							if (dialogBody) {
								dialogBody.scrollTop = 0;
							}
						}
					});

					
				}
			}

		},
		mounted() {
			app = this
			console.log(this)
			let roleId = this.$route.query.roleId
			let roleName = this.$route.query.roleName
			this.roleId = roleId
			this.roleName = roleName
			let height = $(window).height() - 170
			$('.content').css({
				"height": height
			})
			$('#treeDemo,#treeDemo1').css({
				"max-height": height
			})
			axios({
				method: "get",
				url: apiData.businessSystemList,
				params: {roleId:this.roleId}
			}).then(res=>{
				let data = res.data.data
				this.options = data.list
				this.value = this.options.find(item=>item.id == this?.switchboardIdentity?.businessSystemId).id
				this.getList()
			})
			// 列表页保持搜索状态
			sessionStorage.setItem("searchFlag", true);
		},
	methods: {
			submitUpload() {
				this.$refs.upload.submit();
				this.loading = true
			},
			handleAvatarBefore(res, file){
				console.log(res,file)
			},
			//角色导入历史查询接口
			getRoleMenuGetImportLog() {
				let _this = this;
				http.get(apiData.roleMenuGetImportLog, true, {}, (res) => {
					if (res.data.code == 200) {
						_this.roleMenuGetImportLog = res.data.data;
					}else{
						_this.$message.error(res.data.msg);
					}
				});
			},
			/**
				* @description: 设置数仓权限下载模版
				* @Author: esther
				* @Date: 2024-04-29 16:14:35
				*/			
			dataWarehouseDownloadTemplate(item) {
				let id = item && item.id ? item.id : ''
				let url = `/organizationstructure/roleMenu/downloadModuleImportTemplate?module_id=${id}`
				console.log(url)
				window.open(url);
			},
			/**
			* @description: 设置数仓权限上传模版成功
			* @param {*} err
			* @Author: esther
			* @Date: 2024-05-03 13:52:36
			*/			
			handleAvatarSuccess(res, file) {
				let _this = this;
				if (res.code == 200) {
					_this.$nextTick(function () {
						_this.$message.success(res.msg);
						_this.loading = false
						_this.dialogDataWarehouseUploadTemplateVisible = false
					});
					_this.num = res.data;
					_this.$refs.upload.clearFiles();
				} else if (res.code == 400) {
					_this.errorMsgList = [];
					let msg = JSON.parse(res.msg)
					console.log(msg)
					if(msg.type == 1){//字符串
						_this.errorMsgList = [msg.msg]
					}else if(msg.type == 2) {//字符串数组
						_this.errorMsgList = msg.msg
					}
					console.log(_this.errorMsgList)
					_this.templateVisibleType = 1
					_this.loading = false
					console.log("error", _this.errorMsgList);
				}
			},
			/**
			* @description: 设置数仓权限上传模版错误
			* @param {*} err
			* @Author: esther
			* @Date: 2024-05-03 13:52:36
			*/			
			handleAvatarError(res, file) {
				let _this = this
				_this.loading = false
				_this.$nextTick(function () {
					_this.$message.error(res.msg);
					
				});
				_this.loading = false
			},
			/**
				* @description: 设置数仓权限上传模版-弹框
				* @Author: esther
				* @Date: 2024-04-29 16:27:18
				*/
			dataWarehouseUploadTemplateBefore() {
				let _this = this
				_this.templateVisibleType = 0
				_this.dialogDataWarehouseUploadTemplateVisible = true
			},					
			dataWarehouseUploadTemplate() {
				let _this = this
				console.log(_this.fileList)
				console.log(_this.$refs.upload)
				if (_this.$refs.upload.uploadFiles && _this.$refs.upload.uploadFiles.length) {
					_this.$refs.upload.submit();
					_this.loading = true
				}else {
					_this.$message.error('请先选择上传文件！');
				}
			},
			/**
				* @description: 设置数仓权限上传模版-弹框-保存
				* @Author: esther
				* @Date: 2024-04-29 16:27:18
				*/						
			dataWarehouseUploadTemplateSave() {
				let url = "UploadSumDataModuleSpecialMeaning.action?module_id="
				window.open(url);
			},
			/**
			 * 关闭提示弹框
			 */
			closePopover() {
				this.$refs.popover.doClose()
			},
			mapAddChecked(obj){
				if(obj.pId2){
					obj.checked = true;
					allTreeItems[obj.pId2].checked = true;
					this.mapAddChecked(allTreeItems[obj.pId2]);
				}else if(obj.pId){
					obj.checked = true;
					allTreeItems[obj.pId].checked = true;
					this.mapAddChecked(allTreeItems[obj.pId]);
				}
			},
			setting() {
				let url;
				if(this.identical){
                   url = `${apiData.roleMenuList}?roleId=${this.roleId}`;
				}else{
				   url = `${apiData.roleMenuDynamicNode}?roleId=${this.roleId}&businessSystemId=${this.value}`;
				}
				return {
					check: {
						enable: false
					},
					view: {
						expandSpeed: "normal",
						fontCss: getFont,
						nameIsHTML: true
					},
					async: {
						enable: true,
						dataFilter: null,
						type: "get",
						autoParam: ["id","tabNum"],
						url
					},
					simpleData: {
						enable: true,
					},
					callback: {
						// onCheck: zTreeOnCheck,
						onClick: this.zTreeOnClick,
						onAsyncSuccess: (event, treeId, treeNode, msg) => {
							console.log(JSON.parse(msg),'msg');
							this.handleZnodes(JSON.parse(msg))
							// 异步加载成功后的回调
						},
						onAsyncError: (event, treeId, treeNode, XMLHttpRequest, textStatus, errorThrown) => {
							// 异步加载失败后的回调
						}
					}
				}
			},
			zTreeOnClick(event, treeId, treeNode) {
				let _this = this
				this.onlyOne = 0;
				this.tabPosition = 'isDefalut';
				this.selectTreeNode = allTreeItems[treeNode.id];
				_this.isWarseHouse = false
				if(this.identical){
					//组织机构权限
					this.childs = this.selectTreeNode.childrenHaveRole
					if(this.childs){
						const childs = this.childs[0].children;
						this.checkedChilds = childs.filter(item=>item.checked);
						this.checkAll = childs.length === this.checkedChilds.length;
						this.isIndeterminate = this.checkedChilds.length > 0 && this.checkedChilds.length < childs.length;
					}else{
						this.checkAll = this.selectTreeNode.checked;
						this.childs = [];
						this.isIndeterminate = false;
					}
				}else{
					//数据权限
					this.childs = this.selectTreeNode.childrenHaveRole && this.selectTreeNode.childrenHaveRole.filter(item=>item.children);
					if(treeNode && treeNode.tabNum == 'warse_house'){//点击的是数仓文件夹
						_this.isWarseHouse = true
						_this.getRoleMenuGetImportLog()
					}
					if(this.childs){
						console.log(this.childs,'this.childs');
						this.childs.reverse();
						this.childs.map((item,index)=>{
							if (!item.children[0]?.eradio) {
								let checkeds = item.children.filter(item => item?.checked)
								this.diffCheckChilds[index] = checkeds;
								// 给小item全选添加状态
								item.isIndeterminate = checkeds.length > 0 && checkeds.length < item.children.length ? true : false;
								if (checkeds && checkeds.length == item.children.length) {
									item.checked = true
								}
							}else{
								this.selectChildId[index] = item.children.find(child=>child.checked) ? item.children.find(child=>child.checked).id : '';
							}
							
						})
            this.handleCheckAllStatus();
					}else{
						this.childs = [];
						this.isIndeterminate = false;
						// this.checkAll = this.selectTreeNode.checked;
						console.log(this.checkAll,'this.checkAll');
					}
				}
				
				
			},
			handleCheckAllStatus(){
				const childsMap = this.childs.map((item,index)=>{
                  if(!item.children[0]?.eradio){
					return this.diffCheckChilds[index].length === item.children.length;
				  }else{
					return this.selectChildId[index];
				  }     
				})
				const childsisIndeterminate = this.childs.map((item,index)=>{
                  if(!item.children[0]?.eradio){
					return this.diffCheckChilds[index].length
				  }else{
					return this.selectChildId[index];
				  }     
				})
				if(!this.childs.find(item=>item.children[0]?.eradio)){
					this.checkAll = !this.childs.find((item,index)=>this.diffCheckChilds[index].length < item.children.length);
                    this.isIndeterminate = Boolean(this.childs.find((item,index)=>this.diffCheckChilds[index].length && this.diffCheckChilds[index].length < item.children.length))   
					// this.selectTreeNode.checked = this.checkAll;
					return
				}
			
				this.isIndeterminate = !(!childsisIndeterminate.filter(item=>item).length || !childsMap.filter(item=>!item).length);
				this.checkAll = !childsMap.filter(item=>!item).length;
				// this.selectTreeNode.checked = this.checkAll;
			},
		changeBandding(id, itemObj, childs,index,target) {
			// item,childs
				let _this = this
				let selectTreeNode = this.selectTreeNode
				// console.log(id, itemObj, childs,_this.selectChildId[index],selectTreeNode1,666)
				// Esther 组织机构表  数据编辑范围和数据查看范围的自定义先屏蔽掉 
				if (selectTreeNode && selectTreeNode.iconSkin.includes('icon502')) {
					if (itemObj.children?.length) {
						let currentBtn = itemObj.children.filter(item => item.name == '自定义' && id == item.id)
						if (currentBtn?.length) {
							if (target && target == 'span') {
							} else {
								_this.selectChildId[index] = ''
								_this.$message.warning('功能开发中，敬请期待');
							}
							return
						}
					}
				}
				// if (itemObj.pId && itemObj.pId.indexOf('warse_hous') != (-1) && child && child.name && child.name == '自定义') {
				//  this.$message.warning('此功能暂未开放！');
				//  return
				// }
		    const val = itemObj.children.find(child => child.id === id);
			  this.childs.find( item=> item.id === itemObj.id).children.map(child=>{
				child.checked = child.id === id
			  })
			  itemObj.checked = true;
			  allTreeItems[id].checked = true;
			  allTreeItems[itemObj.id].checked = true;        
			  this.handleCheckAllStatus();
			  console.log('哦哦偶的事这里--45',val)
        			if(val.name==='自定义'){
					var pId = val.pId;
					var form_id = pId.split("_")[1];
					app.dialogFormVisible = true
					if (organizationAndFilterRoleMenuNode && organizationAndFilterRoleMenuNode.pId && organizationAndFilterRoleMenuNode.pId == val.pId) {
						app.formId = form_id
						app.menuId = pId
						isCanDelete = false
					} else {
						isCanDelete = true
						// if(!this.onlyOne){
						app.formId = form_id
						app.menuId = pId
						app.getTreeData();
						this.onlyOne++;
						// }
					}
					organizationAndFilterRoleMenuNode = val;
			  }
			},
			// indeterminateSub(data){
			// 	if (data && data.children && data.children.length) {
			// 		let checkeds = data.children.filter(item => item.checked)
			// 		data.isIndeterminate = checkeds > 0 && checkeds < data.children.length;
			// 		console.log(data.isIndeterminate)
			// 		return data.isIndeterminate
			// 	}
			// 	console.log(data)
			// 	// console.log(checkeds)

			// },
			handleCheckAllSubChange(val,ids) {
				let _this = this
				let childs = _this.childs
				if (_this.identical) {//组织机构权限
					
				} else {//数据权限
					_this.childs[ids].isIndeterminate = false;
					childs[ids].children.map((item,index)=>{
						item.checked = val
						allTreeItems[item.id].checked = val;
					})
					_this.diffCheckChilds[ids] = val ? childs[ids].children : [];
					this.handleCheckAllStatus()
				}
				console.log(this.childs)
			},
			handleCheckAllChange(val) {
				if(this.identical){//组织机构权限
					if(this.childs.length){
						this.checkedChilds = val ? this.childs[0].children : [];
						this.isIndeterminate = false;
						// this.selectTreeNode.checked = val;
						this.childs[0].children.map(item=>{
							item.checked = val;
							allTreeItems[item.id].checked = val;
						})
					}else{
						// this.selectTreeNode.checked = val;
					}
					
				} else {//数据权限
					this.isIndeterminate = false;
					// this.selectTreeNode.checked = val;
					this.childs.map((item, index) => {
						if(!item.children[0]?.eradio) {
							item.checked = val; //大全选的时候修改小全选状态
							item.children.map(child=>{
								child.checked = val;
								allTreeItems[child.id].checked = val;
							})
							allTreeItems[item.id].checked = val;
							this.diffCheckChilds[index] = val ? item.children : [];
						}else{ 
							this.selectChildId[index] = val ? item.children[0].id : '';
							item.children[0].checked = val;
							allTreeItems[item.children[0].id].checked = val;
							allTreeItems[item.id].checked = val;
						}
					})
				}
				
			},
			handlecheckedChildsChange(value) {
				let checkedCount = value.length;
				const childs = this.childs[0].children
				this.checkAll = checkedCount === childs.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < childs.length;
				if(childs){
					this.childs[0].children.map(item=>{
						item.checked = value.includes(item);
						
					});
				}        
			},
			handleDiffcheckedChildsChange(itemObj,index){
				// this.selectTreeNode.checked = this.checkAll;
				let _this = this
				let checkeds = 0
				itemObj.children.map(child => {
					child.checked = this.diffCheckChilds[index].includes(child)
					allTreeItems[child.id].checked = this.diffCheckChilds[index].includes(child)
					if (child.checked) {
						checkeds = checkeds + 1
					}
				})
				allTreeItems[itemObj.id].checked = Boolean(itemObj.children.find(item=>item.checked));
				let isIndeterminate = false
				isIndeterminate = checkeds > 0 && checkeds < itemObj.children.length ? true : false;
				_this.$set(_this.childs[index],'isIndeterminate', isIndeterminate)
				_this.$set(_this.childs[index],'test', checkeds)
				this.handleCheckAllStatus()
			},
			initSelectNode(){
              this.selectTreeNode = {};
			  allTreeItems = {};
			  this.childs = [];
			},
			changeSelectBtn(index){
			    this.initSelectNode();
				if(index === 1){
                  this.getRightList();
				}else{
				  this.getList();
				}
                this.currentIndex = index; 
			},
			close(){
				this.dialogFormVisible = false
			},
			// close2(){
			// 	this.dialogFormVisible2 = false
			// },
			saveCustomize(){
				let _this = this
				var treeObj = $.fn.zTree.getZTreeObj("treeDemo2");
				var nodes = treeObj?.getCheckedNodes(true) || [];
				let valueString = '';
				
				// console.log('数据',)
				// return
				if(this.isModuleStatistics){
					const haveValue = this.dataNotDefaultList.filter(item=>item.value);
					valueString = haveValue.map(item=>`${item.id}_${item.value}-${item.type}`).join(',');
				}
				
				if(nodes.length==0){
					if(this.isModuleStatistics){
						selectOrganizationAndFilter(valueString, "");
					}else{
						_this.$dialog.toast(_this,'请至少选择一个组织机构或过滤条件')
						return
						
						selectOrganizationAndFilter("", "");

					}
				}else{
					var node;
					var ids = "";
					for (var i=0; i<nodes.length; i++) {
						node = nodes[i];
						ids = ids+node.id+"-"+node.type+",";
					}
					if(this.isModuleStatistics){
						ids = ids + valueString;
					}
					selectOrganizationAndFilter(ids, "");
				}
				this.close()
			},
			// saveCustomize2(){

			// },
			// 递归勾选子节点
			checkAllChildNodes(treeObj, node) {
				if (node && node.children) {
					node.children.forEach(childNode => {
						treeObj.checkNode(childNode, true, true);
						this.checkAllChildNodes(treeObj, childNode);
					});
				}
			},
			getTreeData(){
				let _this = this
							console.log('哦哦偶的事这里--1')

				_this.isDilogLoading = true
				let params = {
					businessSystemId: this.value,
					formId: this.formId,
					menuId: this.menuId,
					roleId: this.roleId,
					isHideLoading: true
				}
				http.get(apiData.roleMenuCustomize, true, params, (res) => {
					let data = res.data.data || [];
					let dataIsDefault; 
					if(data.find(item=>item.id==='moduleRow')){
						this.isModuleStatistics = true;
						dataIsDefault = data.find(item=>item.id==='moduleStatistics')?.children ? data.find(item=>item.id==='moduleStatistics').children : [];
						this.dataNotDefaultList = data.find(item=>item.id==='moduleRow').children.map(item=>{
							item.value = item.value || '';
							return item;
						});
					}else{
						this.isModuleStatistics = false;
						dataIsDefault = data;
					}
								console.log('哦哦偶的事这里--5')

					this.dialogFormVisible = true;
					_this.setting2.async.url = `${apiData.roleMenuCustomizeSon}?formId=${_this.formId}&menuId=${_this.menuId}&roleId=${_this.roleId}&businessSystemId=${_this.value}`
					// 000将tree2修改为全局变量
					this.dataIsDefault = dataIsDefault;
					if(dataIsDefault.length){
						tree2 = $.fn.zTree.init($("#treeDemo2"), _this.setting2, dataIsDefault);
					}

					// 遍历数据，将半勾选的节点展开
					let isSelData = dataIsDefault?.filter((item) => item.halfCheck || item.checked)
					if(isSelData.length){
						isSelData?.forEach(item=>{
							_this.expandSpecificNode($.fn.zTree.getZTreeObj("treeDemo2"), item.id);
						})
					}else{
						_this.isDilogLoading = false
					}
					
					
				},() =>{
					_this.isDilogLoading = false
				})
			},
			// 自动展开指定节点
		expandSpecificNode(treeObj, nodeId,) {
			let _this = this
			if (!treeObj || !nodeId) return;
			
			// 优先使用传递的节点对象，如果没有则通过ID获取
			let node = treeObj.getNodeByParam("id", nodeId);
			console.log('看是否有下一级-展开该节点', node)
			if (node) {
				// 展开该节点
				treeObj.expandNode(node, true, false, false);
				
				// 检查节点是否已经有子节点数据
				if (node.children && node.children.length > 0) {
					// 找出有checked或halfCheck状态的子节点并递归展开
					let selData = node.children.filter(item=>item.checked || item.halfCheck);
					
					if(selData.length){
						selData.forEach(childNode => {
							console.log('看是否有下一级', childNode)
							// 递归展开子节点
							_this.expandSpecificNode(treeObj, childNode.id);
						});
					}
					_this.isDilogLoading = false
				}
			}
		},
			// labelCheckedList接收被勾选的数据
			handleCheckChange(data) {
				this.currTreeId = data.id
				setTimeout(() => {
					let currtData = this.$refs.tree.getCheckedNodes(true)
					this.labelCheckedList = currtData;
				}, 100);
			},
			//懒加载时触发
			loadNode(node, resolve) {
				if (node.level === 0) {
					this.getCategorylist(resolve)
					// return resolve(this.categorylist);
				}
				if (node.data && !node.data.isParent) return resolve([]);
				if (node.level > 0) { // 二级节点
					this.getChildrenNode(node, resolve)
				}
			},
			// 二级节点
			getChildrenNode(node, resolve) {
				let params = {
					businessSystemId: this.value,
					formId: this.formId,
					menuId: this.menuId,
					roleId: this.roleId,
					id: node.data.id,
					type: node.data.type
				}
				http.get(apiData.roleMenuCustomizeSon, true, params, (res) => {
					let data = res.data.data;
					this.childrenList = data;
					if (this.childrenList.length == 0) {
						this.$message.error('数据拉取失败，请刷新再试！');
						return;
					}
					resolve(data);
				})
			},
			// 收起、展示tree
			selectLabelList() {
				if (!this.isShowTree) {
					this.getCategorylist();
				} else {
					this.$refs.tree.$data.store.lazy = false
					this.isShowTree = false;
				}

			},
			//获取一级节点
			getCategorylist(resolve) {
				let params = {
					businessSystemId: this.value,
					formId: this.formId,
					menuId: this.menuId,
					roleId: this.roleId
				}
				http.get(apiData.roleMenuCustomize, true, params, (res) => {
					let data = res.data.data;
					if (data.length > 0) {
						data.forEach(item => {
							item.disabled = true;
						})
					}
					return resolve(data);
					this.categorylist = data;
					this.dialogFormVisible = true;
				})
			},
			back() {
				this.$router.go(-1); //返回上一层
			},
			changeValue() {
				this.initSelectNode()
				this.getRightList()
				console.log(this.value)
			},
			submitRequest(url,datas,type) {
				let _this = this
				let loadingInstance = Loading.service({
					fullscreen: true,
					background: 'rgba(0, 0, 0, .7)'
				});
				axios({
					headers: {
						'Content-Type': 'application/json'
					},
					method: 'put',
					url: url,
					data: JSON.stringify(datas)
				}).then(res => {
					loadingInstance.close();
					console.log(res,'res.status');
					if (res.data.status) {
						if (res.data.code == 200) { //正确返回数据
							http.get(apiData.businessSystemList, true, {roleId:this.roleId}, (res) => {});
							// if (type == 1) { //组织机构权限
							// 	_this.getList()
							// } else if (type == 2) { //数据权限
							// 	_this.getRightList()//接口返回的数据
							// }
							// 000增加保存成功提示框
							Message({
								showClose: true,
								message: res.data.msg,
								type: 'success',
								duration: 5000
							});
						}else{
							Message({
								showClose: true,
								message: res.data.msg,
								type: 'error',
								duration: 5000
							});
						}
						
					} else {
						Message({
							showClose: true,
							message: res.data.msg,
							type: 'error',
							duration: 5000
						});
					}
				})
				.catch(err => {
					alert(err);
					// console.log(err)
				})
			},
			submit(type) {
				let _this = this
				let url = ''
				let businessSystemId = ''
				let params = [];
				if (type == 1) { //组织机构权限
					url = apiData.roleMenuUpdateFixedMenu;
					this.childs.map(item=>{
						item.children.map(child=>{
							params.push(allTreeItems[child.id])
						})
					})
					this.mapPIdIbj(this.selectTreeNode,params);
				} else if (type == 2) { //数据权限
					url = apiData.roleMenuUpdateBusinessSystemMenu
					businessSystemId = '&businessSystemId=' + this.value
					console.log(this.childs,'this.childs');
					this.childs.map(item=>{
						if(allTreeItems[item.id].hasOwnProperty('treeGrade')){
                          delete allTreeItems[item.id].treeGrade
						}
						params.push(allTreeItems[item.id])
						item.children.map(child=>{
							// if(allTreeItems[child.id].hasOwnProperty('treeGrade')){
							// 	delete allTreeItems[child.id].treeGrade
							// }
							// allTreeItems[child.id].pId = item.id;
							// console.log(allTreeItems[child.id],'child.id');
							// params.push(allTreeItems[child.id])
							if(child.hasOwnProperty('treeGrade')){
							   delete child.treeGrade
							}
							if(item.name==='数据查看范围' && !item.checked){
								child.checked = false;
							}
							params.push(child);
						})
					})
					this.mapPIdIbj(this.selectTreeNode,params);
					const par = JSON.parse(JSON.stringify(params));
					par.map(item=>{
						if(item.hasOwnProperty('children')){
							delete item.children
						}
						if(item.hasOwnProperty('childrenHaveRole')){
							delete item.childrenHaveRole
						}
					})
					params = par;
				}
				url = url + '?roleId=' + this.roleId + '&HncToken=' + localStorage.getItem('token') + businessSystemId;
				_this.submitRequest(url, params, type);

			},

            mapPIdIbj(obj,params){
				if(allTreeItems[obj.id].hasOwnProperty('treeGrade')){
					delete allTreeItems[obj.id].treeGrade
				}
				params.push(allTreeItems[obj.id]);
				if(obj.pId2){
                  this.mapPIdIbj(allTreeItems[obj.pId2],params);
				}else if(obj.pId){
				  this.mapPIdIbj(allTreeItems[obj.pId],params);
				}	
			},

			// 数据权限下面数据报表管理
			getRightList() {

				let _this = this;
				let roleId = this.roleId
				let params = {
					roleId,
					businessSystemId: this.value
				}
				axios({
					method: "get",
					url: apiData.roleMenuDynamicNode,
					params: params
				}).then(res=>{
					let zNodes = res.data;
					_this.zNodes1 = zNodes
					_this.handleZnodes(zNodes);
					$.fn.zTree.init($("#treeDemo1"), _this.setting(), zNodes);
					// modifyHistoryTime()
				})
			},
			handleZnodes(data) {
				data.map(item=>{
					if(item){
						item.checked = item.checked ? item.checked : false;
						allTreeItems[item.id] = item;
						if(!item.pId){
							item.treeGrade = item.name;
						}else{
							item.treeGrade = `${allTreeItems[item.pId]?.treeGrade}/${item.name}`;
						}
						if(item.children){
							this.handleZnodes(item.children);
						}
						if(item.childrenHaveRole){
							this.handleZnodes(item.childrenHaveRole);
						}
					}
				})  
			},
			getList() {
				let _this = this;
				let roleId = this.roleId
				let params = {
					roleId
				}
				axios({
					method: "get",
					url: apiData.roleMenuList,
					params: params
				}).then(res=>{
					let zNodes = res.data
					_this.zNodes = zNodes
					_this.handleZnodes(zNodes);
					$.fn.zTree.init($("#treeDemo"), _this.setting(), zNodes);
				})
			},
			retSuper() {
				this.$router.go(-1);
			},
		},
	};
</script>

<style lang="less" scoped>
	/deep/
	.disabled-radio {
		opacity: 0.5;
	}
	/deep/ .ztree li span.button.ico_docu{
		background-position: -110px -2px;
	}
	/deep/.el-dialog__body {
		max-height: 450px;
		min-height: 450px !important;
		overflow: auto;
	}
	.b {
		margin: 0 !important;

		.info {
			margin: 10px 0;
			text-align: left;
		}

		.content {
			text-align: left;

			.rbac {
				height: 100%;
				display: flex;
				background: #f8f8f8;
				padding-top: 10px;
				padding-bottom: 10px;
				.tips {
					flex: 1;
					padding-right: 10px;
					height: 100%;
					display: flex;
					flex-flow: column;
					justify-content: space-between;
					.check-group-cont{
						height: calc(100vh - 296px);
						overflow: auto;
						padding: 20px;
						background: #fff;
					}
					.red-txt {
						color: red;
					}
					

					font-size: 12px;
					line-height: 1.5;
				}

				.tablelist {
					float: left;
					height: 100%;
					width: 578px;
					margin-right: 10px;
					margin-left: 10px;
					background: #fff;
                    .tablelist-topnav {
                      display: flex;
					  justify-content: space-between;
					  background: #55C4B8;
					  height: 48px;
					  align-items: center;
					  padding: 0 24px 0 6px;
					  .topnav-btns{
						display: flex;
                        div{
							width: 107px;
							height: 32px;
							background: #FFFFFF;
							border-radius: 6px 6px 6px 6px;
							font-size: 16px;
							text-align: center;
							line-height: 32px;
							color: #666;
							cursor: pointer;
							&:last-child{
								margin-left: 24px;
							}
							&.active{
							   color: #55C4B8;
							}
						}
					  }
					}
					#treeDemo {
						height: calc(100% - 30px);
						overflow: auto;
					}

					#treeDemo1 {
						height: calc(100% - 30px);
						overflow: auto;
					}
				}
			}
		}
	}
	.ztree{
		background: #fff;
	}
	.el-btn-common{
		width: 200px;
		height: 40px;
	}
	.el-check-all{
		box-sizing: border-box;
        height: 48px;
		line-height: 48px;
		color: #333;
		/deep/ .el-checkbox__label{
           width: auto !important;
		}
	}
	.el-check-all-sub {
		margin-right: 10px !important;
	}
	.dian1{
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	.el-check-group{
		min-height: 76px;
		background: rgba(85, 196, 184, .1);
    border-radius: 4px 4px 4px 4px;
		padding: 12px 12px 12px 24px;
		margin-bottom: 12px;
		/deep/ .el-checkbox__label{
			color: #333;
		}
		p,.el-check-group-title{
			margin-bottom: 12px;
			color: #333;
			font-size: 14px;
		}
		.el-check-group-title {
			display: flex;
		}
	}
	.check-bottom-btns{
		display: flex;
		justify-content: center;
		background: #fff;
		padding-bottom: 10px;
		padding-top: 10px;
	}
	.tip-div{
		background: #fff;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		line-height: 24px;
		text-align: left;
		font-style: normal;
		.el-popover__reference {
			text-align: center;
			color: #666;
			&:hover {
				opacity: 0.8;
				cursor: pointer;
			}
		}
	}
	/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
		color: #55CCB8;
	}
	/deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
		border-color: #55CCB8;
	}
	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
		background-color: #fff;
    	border-color: #55CCB8;
	}
	/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner:before{
		background-color: #55CCB8;
	}
	/deep/ .el-checkbox__inner:after{
		box-sizing: content-box;
		content: "";
		border: 1px solid #55CCB8;
		border-left: 0;
		border-top: 0;
		height: 7px;
		left: 4px;
		position: absolute;
		top: 1px;
		transform: rotate(45deg) scaleY(0);
		width: 3px;
		transition: transform .15s ease-in .05s;
		transform-origin: center;
	}
	/deep/ .el-checkbox__inner:hover {
    	border-color: #55CCB8 !important;
    }
	.breadCrumb{
		padding-left: 10px;
	}
	/deep/ .el-radio-group{
		line-height: 24px;
	}
	/deep/ .el-checkbox-group{
		line-height: 24px;
	}
	/deep/ .el-checkbox__label{
		width: 192px;
		font-size: 12px;
		padding-left: 6px;
	}
	/deep/ .el-radio__label{
		width: 80px;
		display: inline-block;
		font-size: 12px;
	}
	/deep/ .el-checkbox{
		margin-right: 0 !important;
	}
	/deep/ .el-radio__input.is-checked .el-radio__inner{
		background-color: #55CCB8;
    	border-color: #55CCB8;
	}
	/deep/ .el-radio__input.is-checked+.el-radio__label{
		color: #606266 !important;
	}
	/deep/ .el-radio__inner:hover{
		border-color: #55CCB8;
	}
	/deep/ .icon08_ico_docu, /deep/ .icon08_role_ico_docu, .icon08 {
		width: 14px !important;
		height: 15px !important;
		margin-right: 4px !important;
		margin-top: 2px;
		background: url(../../images/report.png) no-repeat center
			center !important;
		background-size: 80%;
		position: relative;
		// background-position:14px 14px;
	}
	/deep/ .icon09_ico_docu, /deep/ .icon09_role_ico_docu, .icon09 {
		width: 14px !important;
		height: 15px !important;
		margin-right: 4px !important;
		margin-top: 2px;
		background: url(../../images/form.png) no-repeat center
			center !important;
		background-size: 80%;
		position: relative;
		// background-position:14px 14px;
	}
	/deep/ .icon11_ico_docu, /deep/ .icon11_role_ico_docu, .icon11 {
		width: 14px !important;
		height: 15px !important;
		margin-right: 4px !important;
		margin-top: 2px;
		background: url(../../images/form_index.png) no-repeat center
			center !important;
		background-size: 80%;
		// background-position:14px 14px;
	}
	/deep/  .icon10_ico_docu, /deep/ .icon10_role_ico_docu, .icon10{
		width: 14px !important;
		height: 15px !important;
		margin-right: 4px !important;
		margin-top: 2px;
		background: url(../../images/form_red.png) no-repeat center
			center !important;
		background-size: 80%;
	}
	/deep/  .icon50_ico_docu, /deep/ .icon50_role_ico_docu, .icon50{
		width: 14px !important;
		height: 15px !important;
		margin-right: 4px !important;
		margin-top: 2px;
		background: url(../../images/watch/icon_50.png) no-repeat center
			center !important;
		background-size: 80%;
	}
	/deep/  .icon502_ico_docu, /deep/ .icon502_role_ico_docu, .icon502{
		width: 14px !important;
		height: 15px !important;
		margin-right: 4px !important;
		margin-top: 2px;
		background: url(../../images/watch/icon_502.png) no-repeat center
			center !important;
		background-size: 100% !important;
	}
	/deep/ .icon08_role_ico_docu, /deep/ .icon09_role_ico_docu, /deep/ .icon10_role_ico_docu, /deep/ .icon11_role_ico_docu, /deep/ .icon50_role_ico_docu, /deep/ .icon502_role_ico_docu{
		margin-right: 30px !important;
	}
	/deep/ .icon08_role_ico_docu::after, /deep/ .icon09_role_ico_docu::after, /deep/ .icon10_role_ico_docu::after, /deep/ .icon11_role_ico_docu::after, /deep/ .icon50_role_ico_docu::after, /deep/ .icon502_role_ico_docu::after{
		content: '权限'; /* 插入的文字 */
		top: 8px;
		left: 18px;
		background: rgba(245, 223, 210, 1);
		color: rgba(206, 94, 31, 1);
		margin-left: 18px;
		line-height: 14px;
	}
	/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
		color: #606266 !important;
	}
	/deep/ .el-button--primary{
		border: none;
	}
	/deep/ .el-button.el-button--default{
		border-color: #55CCB8;
		color: #55CCB8;
		&:hover{
			border-color: #55CCB8;
			color: #55CCB8;
		}
	}
	/deep/ .ztree li a.curSelectedNode, /deep/ .ztree li a.curSelectedNode_Edit{
        background: none;
		border:none;
		color: #55CCB8;   
	}
	/deep/ .ztree li a:hover {
		text-decoration: none;
	}
	/deep/ .ztree li span.button{
		// background-image: url('../../images/zTree-icon.png');
	}
	/deep/ .ztree * {
       font-family: Microsoft Yahei,微软雅黑,arial!important;
	}
	/deep/ .role_ico_close, /deep/ .role_ico_open, /deep/ .role_ico_docu{
		margin-right: 30px !important;
		background-position: -110px 0;
		vertical-align: top;
		&::after{
			content: '权限'; /* 插入的文字 */
			top: 8px;
			left: 18px;
			background: rgba(245, 223, 210, 1);
			color: rgba(206, 94, 31, 1);
			margin-left: 18px;
			line-height: 14px;
		}
	}
	/deep/ .el-button--primary.is-disabled{
		background-color: #ccc;
	}
	/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
		color: #FFF;
		background-color: #55c4b8;
		border-color: #55c4b8;
		box-shadow: -1px 0 0 0 #55c4b8;
	}
	/deep/ .el-radio-button__inner:hover{
		color: #55c4b8;
	}
</style>
<style lang="less">
.rolePopover {
	box-shadow: 0 2px 12px 0 rgba(0,0,0,.7);
	.tip-div-txt {
		position: relative;
		line-height: 24px;
		font-size: 12px;
		.close {
			position: absolute;
			right: 0;
			top: 0;
			display: flex;
			line-height: 10px;
			justify-content: center;
			width: 14px;
			height: 14px;
			font-size: 14px;
			border-radius: 50%;
			border: 1px solid #666;
			&:hover {
				cursor: pointer;
				opacity: 0.8;
			}
		}
		.red-txt {
			color: #F33939;
		}
	}
}
.item-btn {
	
}
.el-check-group {
	.item-btn {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 10px;
		width: 52px;
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #fff;
		background: #55C4B8;
		border-radius: 2px 2px 2px 2px;
		&::after {
			margin-left: 4px;
			content: '';
			display: inline-block;
			width: 12px;
			height: 12px;
			background: red;
		}
		&.upload {
			&::after {
				background: url('../../images/roleAuthority/upload.png') no-repeat;
				background-size: 100% 100%;
			}
		}
		&.download {
			&::after {
				background: url('../../images/roleAuthority/download.png') no-repeat;
				background-size: 100% 100%;
			}
		}
		&:hover {
			cursor: pointer;
		}
	}
}

.excel-box {
	display: flex;
	justify-content: space-between;
	.item {
		display: flex;
		width: 33%;
		position: relative;
		padding: 12px 8px 12px 8px;
		background: #fff;
		border: 1px solid #DCDCDC;
		border-radius: 3px;
		.item-l {
			flex: 1;
			padding-left: 22px;
			font-size: 12px;
			overflow: hidden;
			&>div {
				width: 100%;
				white-space: nowrap; /* 确保文本在一行内显示 */
				overflow: hidden; /* 隐藏溢出的内容 */
				text-overflow: ellipsis; 
				color: #666666;
			}
			.date {
				color: #999;
				transform: scale(0.9);
				transform-origin: left center;
			}
			&::before {
				position: absolute;
				top: 13px;
				left: 8px;
				display: inline-block;
				margin-right: 8px;
				content: '';
				width: 16px;
				height: 16px;
				background: url('../../images/roleAuthority/excel.png') no-repeat;
				background-size: 100% 100%;
			}
		}
	}
}
// 上传定制数仓批量权限模版
.upload-template {
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 16px;
	color: #666666;
	.content {
		display: flex;
		align-items: center;
	}
	.el-upload-list__item {
		margin-top: 0;
	}
}
.hnc-dialog {
	.error-box {
		font-weight: 400;
		font-size: 16px;
		color: #666;
		.title {
			margin-bottom: 16px;
		}
		.blue-txt {
			color: #88BCF5;
		}
		.lists {
			max-height: 200px;
			overflow: auto;
			font-size: 14px;
			.item {
				line-height: 1.5;
			}
		}
	}
	.el-dialog__header {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0;
		height: 40px;
		background: #55C4B8;
		.el-dialog__title {
			font-size: 16px;
			color: #fff;
		}
		.el-dialog__headerbtn {
			top: 50%;
			right: 18px;
			width: 20px;
			height: 20px;
			border: 1px solid #fff;
			transform: translate(0, -50%);
			border-radius: 50%;
			.el-icon {
				color: #fff;
			}
		}
	}
	.el-upload-tip {
		margin-top: 16px;
		display: flex;
		font-weight: 400;
		font-size: 16px;
		color: #666666;
		line-height: 22px;
	}
}
/deep/ .el-button--primary.is-plain{
	color: #55c4b7!important;
    background-color: #fff!important;
    border-color: #55c4b7!important;
}

.el-popover--plain{
	padding: 9px 10px!important;
}
</style>